import { forEach, get, set } from 'lodash-es';
import * as types from './mutations-types';
import { clientApi } from '@phoenix/clientApi';
import { closeModal, showModal } from '@phoenix/helpers/modal-helper';

const initialState = {
  addresses: {},
  suggestedAddress: {},
  isLoading: false,

  addressToDelete: {},
  addressFormModalId: 'address-form-modal',
  addressDeleteConfirmationModalId: 'address-delete-confirmation-modal',
};

const getters = {};

const actions = {
  async loadAddresses({ commit }) {
    commit(types.MY_ACCOUNT_ADDRESSES_LOAD);
    const { data } = await clientApi.get(window.route('api.customer.address.index'));

    commit(types.MY_ACCOUNT_ADDRESSES_LOAD_SUCCESS, data.data.addresses);
  },

  async setAsDefault({ state, commit }, addressId) {
    commit(types.MY_ACCOUNT_ADDRESSES_SET_DEFAULT, { addressId });

    const address = JSON.parse(JSON.stringify(state.addresses[addressId]));
    address.default = true;
    try {
      await clientApi.post(window.route('api.customer.address.store'), address);
    } catch (error) {
      window.Phoenix.sentry.captureException(error);
      throw error;
    }

    commit(types.MY_ACCOUNT_ADDRESSES_SET_DEFAULT_SUCCESS, { addressId });
  },

  async acceptSuggestion({ commit, dispatch, state }, address) {
    try {
      const response = await clientApi.post(window.route('api.customer.address.store'), address);
      commit(types.MY_ACCOUNT_SUGGESTED_ADDRESSES_ACCEPT_SUCCESS, response.data.data.address);
      dispatch('customerAddressForm/closeFormModal', state.addressFormModalId, {
        root: true,
      });
    } catch (error) {
      window.Phoenix.sentry.captureException(error);
      throw error;
    }
  },

  onAddressSavedSuccess({ commit, dispatch, state }, response) {
    commit(types.MY_ACCOUNT_SUGGESTED_ADDRESSES_ACCEPT_SUCCESS, response.data.data.address);
    dispatch('customerAddressForm/closeFormModal', state.addressFormModalId, {
      root: true,
    });
  },

  declineSuggestion({ commit }) {
    commit(`customerAddressForm/${types.CUSTOMER_ADDRESS_SUGGESTED_ADDRESSES_DELETE}`, null, {
      root: true,
    });
  },

  async deleteAddress({ commit, dispatch }, addressId) {
    try {
      await clientApi.delete(window.route('api.customer.address.delete', { addressId }));
    } catch (error) {
      window.Phoenix.sentry.captureException(error);
      dispatch('closeDeleteConfirmationModal');

      throw error;
    }

    dispatch('closeDeleteConfirmationModal');
    commit(`customerAddressForm/${types.CUSTOMER_ADDRESS_SUGGESTED_ADDRESSES_DELETE}`, null, { root: true });
    commit(types.MY_ACCOUNT_ADDRESSES_DELETE_SUCCESS, { addressId });
  },

  openDeleteConfirmationModal({ commit, state }, addressId) {
    commit(types.MY_ACCOUNT_ADDRESSES_OPEN_DELETE_CONFIRMATION_MODAL, {
      addressId,
    });

    showModal(state.addressDeleteConfirmationModalId);
  },

  closeDeleteConfirmationModal({ state }) {
    closeModal(state.addressDeleteConfirmationModalId);
  },
};

const mutations = {
  [types.MY_ACCOUNT_ADDRESSES_LOAD_SUCCESS](state, addresses) {
    state.addresses = Object.assign({}, ...addresses.map((address) => ({ [address.id]: address })));
    state.isLoading = false;
  },

  [types.MY_ACCOUNT_ADDRESSES_LOAD](state) {
    state.isLoading = true;
  },

  [types.MY_ACCOUNT_ADDRESSES_OPEN_DELETE_CONFIRMATION_MODAL](state, { addressId }) {
    state.addressToDelete = addressId !== null ? get(state.addresses, addressId) : {};
  },

  [types.MY_ACCOUNT_ADDRESSES_DELETE_SUCCESS](state, { addressId }) {
    delete state.addresses[addressId];
  },

  [types.MY_ACCOUNT_ADDRESSES_SET_DEFAULT]() {},

  [types.MY_ACCOUNT_ADDRESSES_SET_DEFAULT_SUCCESS](state, { addressId }) {
    forEach(state.addresses, (address) => {
      address.default = addressId === address.id;
      set(state.addresses, [address.id], address);
    });
  },

  [types.MY_ACCOUNT_ADDRESSES_SAVE]() {},

  [types.MY_ACCOUNT_ADDRESSES_SAVE_SUCCESS](state, { address }) {
    set(state.addresses, [address.id], address);
  },

  [types.MY_ACCOUNT_SUGGESTED_ADDRESSES_ACCEPT_SUCCESS](state, address) {
    set(state.addresses, [address.id], address);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
